import ShadowWrapper from "components/Common/ShadowWrapper";
import { useModal } from "src/hooks/useModal";
import { useRouter } from "src/hooks/useRouter";


const TermsComp = () => {
  const { openTermsService } = useModal();
  const { router, lang } = useRouter()
  const htmlContent = `
    <!doctype html>
<html lang="ko">
  <head>
    <meta charset="UTF-8" />
    <title>파수에이아이 클라우드 서비스 이용약관 개정 안내</title>
    <style>
      html, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, blockquote, pre, abbr, address, cite, code, del, dfn, em, img, ins, kbd, q, samp, small, strong, sub, sup, var, b, i, a, dl, dt, dd, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, figcaption, figure, footer, header, hgroup, menu, nav, section, summary, time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        text-decoration: none;
      }
      table {
        border-collapse: collapse;
        width: 100%;
      }
      body {
        font-family: "Noto Sans KR", Sans-serif;
        color: #333;
      }
      h1 {
        font-size: 24px;
        text-align: center;
        padding: 40px 0 20px 0;
      }
      /* 개정 요약 박스 스타일 */
      .summary-box {
        width: 90%;
        margin: 0 auto 30px auto;
        padding: 25px;
        background-color: #f9f9f9;
        border: 1px solid #eee;
        border-radius: 8px;
      }
      .summary-item {
        margin-bottom: 15px;
      }
      .summary-item:last-child {
        margin-bottom: 0;
      }
      .summary-title {
        font-weight: bold;
        font-size: 15px;
        margin-bottom: 8px;
        color: #000;
        display: block;
      }
      .summary-content {
        font-size: 14px;
        line-height: 1.6;
        color: #666;
        list-style: none;
      }
      .summary-content li {
        position: relative;
        padding-left: 12px;
      }
      .summary-content li::before {
        content: "•";
        position: absolute;
        left: 0;
        color: #ccc;
      }
      .data-tb {
        width: 90%;
        margin: 20px auto;
        overflow-x: auto;
      }
      .data-tb table, .data-tb th, .data-tb td {
        border: 1px solid #ececec;
        font-size: 14px;
        line-height: 1.6;
      }
      .data-tb th {
        padding: 12px 10px;
        background-color: rgba(185, 185, 185, 0.08);
      }
      .data-tb td {
        padding: 15px 20px;
        font-size: 13px;
        vertical-align: top;
      }
      .data-tb table th.color {
        font-weight: bold;
        background-color: rgba(61, 219, 135, 0.08);
      }
      .data-tb table th.color-yellow {
        font-weight: bold;
        background-color: rgba(242, 255, 125, 0.08);
      }
      p {
        margin-bottom: 10px;
      }
      p:last-child {
        margin-bottom: 0;
      }
      .highlight {
        color: #e74c3c;
        font-weight: bold;
      }
    </style>
  </head>
  <body>
    <h1>
      파수에이아이 클라우드 서비스 이용약관 개정 안내
    </h1>

    <div class="summary-box">
      <div class="summary-item">
        <span class="summary-title">1. 개정 사유</span>
        <ul class="summary-content">
          <li>서비스 운영 주체(법인명) 변경 반영</li>
          <li>신규 서비스 및 관련 URL 추가에 따른 조항 정비</li>
          <li>공지사항 전달 수단(문자 메시지) 추가 및 관련 위탁사 등록</li>
          <li>서비스 내 모니터링 기능 이용 시 고객의 법적 의무 및 면책 조항 신설</li>
        </ul>
      </div>
      <div class="summary-item">
        <span class="summary-title">2. 주요 개정 항목</span>
        <ul class="summary-content">
          <li><strong>이용약관:</strong> 제1조(사명), 제2조(사이트 URL), 제12조(서비스 목록), 제19조(회원의 의무 및 면책 조항 신설)</li>
          <li><strong>개인정보 처리방침:</strong> 제1조(수집 목적에 문자 메시지 추가), 제4조(위탁 업체 알리고 추가)</li>
        </ul>
      </div>
      <div class="summary-item">
        <span class="summary-title">3. 시행 일자</span>
        <ul class="summary-content">
          <li><strong>2026년 06월 01일</strong></li>
        </ul>
      </div>
      <div style="margin-top: 20px; padding-top: 15px; border-top: 1px dashed #ddd; text-align: right;">
  <a id="privacy-policy-link" style="color: #3ddb87; font-weight: bold; text-decoration: underline;cursor: pointer;">
    개정 이용약관 전문 보기 >
  </a>
</div>
    </div>

    <div class="data-tb">
          <h3>
      파수에이아이 클라우드 서비스 통합 이용약관 신·구조문 대비표
    </h3>
      <table>
        <colgroup>
          <col width="15%" />
          <col width="35%" />
          <col width="35%" />
          <col width="15%" />
        </colgroup>
        <thead>
          <tr>
            <th>구분 (조항)</th>
            <th>현행 (2025년 03월 31일 시행)</th>
            <th class="color">개정안 (2026년 06월 01일 시행)</th>
            <th class="color-yellow">주요 변경 내용</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <strong>사명 및 제1조 (목적)</strong>
            </td>
            <td>
              <p>주식회사 파수 클라우드 서비스 통합 이용약관</p>
              <p>본 약관은 주식회사 파수(이하 “회사”)에서 운영하는 유무선 인터넷 서비스인 Wrapsody Cloud, Wrapsody eCo Cloud, Fasoo DSPM, Mind-SAT 등 모든 클라우드 서비스(이하 “서비스”) 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
            </td>
            <td>
              <p><strong class="highlight">주식회사 파수에이아이</strong> 클라우드 서비스 통합 이용약관</p>
              <p>본 약관은 주식회사 <strong class="highlight">파수에이아이</strong>(이하 “회사”)에서 <strong class="highlight">제공하는 클라우드 서비스(Wrapsody, Wrapsody eCo, Mind-SAT, Fireside, Fasoo DSP, Fasoo DSPM 등, 이하 “서비스”)</strong> 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
            </td>
            <td>
              <p>1. 서비스 운영 주체(법인명) 변경 반영</p>
              <p>2. 신규 클라우드 서비스 명시 및 기존 서비스 표기 순서 조정</p>
            </td>
          </tr>
          <tr>
            <td>
              <strong>제2조 (용어의 정의)</strong>
              <br><span style="font-size:11px; color:#888;">* 제3호 사이트</span>
            </td>
            <td>
              <p>3. 사이트: 서비스를 제공하는 웹 기반 홈페이지(http://*.wrapsody.com, https://cloud.wrapsody.com, https://*.wrapsodyeco.com, https://cloud.wrapsodyeco.com/* 등) 및 관련 애플리케이션을 포함합니다.</p>
            </td>
            <td>
              <p>3. 사이트: 서비스를 제공하는 웹 기반 홈페이지(https://*.wrapsody.com, https://cloud.wrapsody.com, https://*.wrapsodyeco.com, https://cloud.wrapsodyeco.com/*, <strong class="highlight">https://cloud.mind-sat.com, https://*.fireside.fasoo.ai, https://*.fasoodsp.com</strong> 등) 및 관련 애플리케이션을 포함합니다.</p>
            </td>
            <td>
              <p>신규 서비스 추가에 따른 관련 웹사이트 URL 추가</p>
            </td>
          </tr>
          <tr>
            <td>
              <strong>제12조 (서비스의 제공)</strong>
            </td>
            <td>
              <p>회사는 회원에게 아래와 같은 서비스를 제공합니다.</p>
              <p>1. Wrapsody: 암호화된 문서의 편집 및 자산화 서비스</p>
              <p>2. Wrapsody eCo: 암호화된 문서의 편집 및 공유 서비스</p>
              <p>3. Fasoo DSPM: 데이터 보안 태세 관리 서비스</p>
              <p>4. Mind-SAT: 악성메일 모의훈련 및 교육 서비스</p>
            </td>
            <td>
              <p>회사는 회원에게 아래와 같은 서비스를 제공합니다.</p>
              <p>1. Wrapsody: 암호화된 문서의 편집 및 자산화 서비스</p>
              <p>2. Wrapsody eCo: 암호화된 문서의 편집 및 공유 서비스</p>
              <p><strong class="highlight">3. Mind-SAT: 악성메일 모의훈련 및 교육 서비스</strong></p>
              <p><strong class="highlight">4. Fireside: 보안 메신저 서비스</strong></p>
              <p><strong class="highlight">5. Fasoo DSP: 통합 데이터 보안 서비스</strong></p>
              <p><strong class="highlight">6. Fasoo DSPM: 데이터 보안 태세 관리 서비스</strong></p>
            </td>
            <td>
              <p>신규 제공 서비스 목록 추가 및 기존 서비스 순서 조정</p>
            </td>
          </tr>
          <tr>
            <td>
              <strong>제19조 (회원의 의무)</strong>
              <br><span style="font-size:11px; color:#888;">* 관련 문단 신설</span>
            </td>
            <td>
              <p>(기존 1~12호 및 4개 문단 유지)</p>
              <p><em>(해당 내용 없음)</em></p>
            </td>
            <td>
              <p>(기존 1~12호 및 4개 문단 유지)</p>
              <p><strong class="highlight">회원은 서비스를 이용함에 있어 소속 구성원(이하 “멤버”)의 업무 문서, 메신저 메시지 및 제품 기능에 의해 주기적으로 생성되는 PC 화면 캡처 데이터 등 서비스 내 데이터에 접근, 열람 또는 처리할 수 있으며, 이 경우 관련 법령에 따라 멤버로부터 필요한 모든 동의를 적법하게 획득할 책임이 있습니다. 특히 관리자가 멤버의 PC 화면을 확인하는 기능 등 민감할 수 있는 서비스 이용에 대해서는 반드시 사전에 멤버의 동의를 얻어야 합니다.</strong></p>
              <p><strong class="highlight">회원이 멤버의 동의를 얻지 못하거나 적법한 권한 없이 데이터를 처리하여 발생하는 모든 법적 책임 및 멤버와의 분쟁에 대하여 회사는 어떠한 책임도 지지 않으며, 이에 대한 모든 책임과 분쟁 해결은 회원(고객)의 비용과 책임으로 합니다.</strong></p>
            </td>
            <td>
              <p>서비스 내 모니터링 기능(화면 캡처 등) 이용 시 고객(회원)의 법적 의무 및 책임 소재, 제공사 면책 조항 신설</p>
            </td>
          </tr>
          <tr>
            <td>
              <strong>기타 조문 정비</strong>
            </td>
            <td>
              <p><em>(내용 기재 생략)</em></p>
            </td>
            <td>
              <p><em>(내용 기재 생략)</em></p>
            </td>
            <td>
              <p>오탈자 정정, 띄어쓰기 교정 등 의미 변화가 없는 단순 자구 수정</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </body>
</html>
`;
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // shadow DOM 내부에 있는 엘리먼트 클릭을 감지하기 위해 composedPath 사용
    const path = e.nativeEvent.composedPath() as HTMLElement[];
    const isLinkClick = path.some((el) => el.id === "privacy-policy-link");

    if (isLinkClick) {
      router(`/${lang}/terms/v20260601`);
    }
  };
  return (
    <div style={{ fontFamily: "Noto Sans KR" }} onClick={handleClick}>
      <ShadowWrapper htmlContent={htmlContent} />
    </div>
  );
};
export default TermsComp;
